var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageIconRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3077 30.5C14.8026 30.5 14.375 30.325 14.025 29.975C13.675 29.625 13.5 29.1974 13.5 28.6923V15.3077C13.5 14.8026 13.675 14.375 14.025 14.025C14.375 13.675 14.8026 13.5 15.3077 13.5H28.6923C29.1974 13.5 29.625 13.675 29.975 14.025C30.325 14.375 30.5 14.8026 30.5 15.3077V28.6923C30.5 29.1974 30.325 29.625 29.975 29.975C29.625 30.325 29.1974 30.5 28.6923 30.5H15.3077ZM17.654 26.75H26.423C26.6038 26.75 26.7378 26.6679 26.825 26.5038C26.9122 26.3398 26.8987 26.1808 26.7845 26.027L24.4 22.8328C24.3063 22.7122 24.1858 22.652 24.0385 22.652C23.891 22.652 23.7705 22.7122 23.677 22.8328L21.2308 26.0192L19.5923 23.9192C19.4988 23.8051 19.3798 23.748 19.2355 23.748C19.0913 23.748 18.9724 23.8083 18.8787 23.929L17.302 26.027C17.1815 26.1808 17.1648 26.3398 17.252 26.5038C17.3392 26.6679 17.4732 26.75 17.654 26.75Z",
    fill: "#1DA1F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIconRounded);
export default __webpack_public_path__ + "static/media/image_icon_rounded.fe4d06f7c80e4e4630c8b4ca5ab21581.svg";
export { ForwardRef as ReactComponent };